import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/victory-club/user-profile/vc-user-profile';

export const VCProfile = BaseWidget.extend({
    init: function() {
        this.view = can.stache('<vc-user-profile />');
        this._super();
    },
});
